import { render, staticRenderFns } from "./repaire.vue?vue&type=template&id=1ddb0392&"
import script from "./repaire.vue?vue&type=script&lang=js&"
export * from "./repaire.vue?vue&type=script&lang=js&"
import style0 from "./repaire.vue?vue&type=style&index=0&lang=less&scoepd=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports